import { styled } from '@mui/system'

export const Body = styled('div')`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 36px 0;

    p {
        min-height: 26px;
    }
`
